































import Vue from 'vue';
import Component from 'vue-class-component';
import HuntingLicenseMessage from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseMessage.vue';

interface IStepStatus {
  index: number;
  haveError: boolean;
  isDone: boolean;
}

@Component<HuntingLicenseOrderStepper>({
  components: {
    HuntingLicenseMessage,
  },
  props: {
    orderId: {
      type: [Number, String],
      required: true,
    },
    charges: {
      type: Boolean,
      default: false,
    },
  },
})
export default class HuntingLicenseOrderStepper extends Vue {
  orderId!: string | number;

  title: string = 'Заявление на выдачу разрешения на добычу охотничьих ресурсов';

  activeStep: string = '1';

  mounted() {
    const { step } = this.$route.query;
    if (step) {
      this.activeStep = step as string;
    }
  }
}
